import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Paper, Tab, Tabs } from '@mui/material';

import VisibilityLayers from '../../components/maps/VisibilityLayers';
import { LayerType } from '../../models/types/layerType';

const PageLayersDelen: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);

  const onTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  }

  return (
    <>
      <header className="app-header">
        <h1>Zichtbaarheid kaartlagen</h1>
        <p className="header-sub-title">
          Beheer welke kaartlagen binnen jouw organisatie zichtbaar en beschikbaar zijn voor collega's.<br/> 
          Verberg overbodige lagen om de keuzelijst overzichtelijk te houden. 
        </p>
      </header>

      <div className="content text-left">
        <Tabs
          value={tabValue}
          onChange={onTabChange}
          aria-label="icon position tabs example"
        >
          <Tab iconPosition="start" label="Openbare kaartlagen" />
          <Tab label="Organisatie kaartlagen" />
        </Tabs>
        {tabValue === 0 && (
          <Paper sx={{ width: '100%' }}>
            <div className="header">
              <h4>Openbare kaartlagen</h4>
              <p>
                U kunt per openbare kaartlaag instellen welke u binnen uw organisatie zichtbaar wilt maken voor collega's.
              </p>

              <VisibilityLayers layerType={LayerType.PUBLIC} />
            </div>
            
          </Paper>
        )}
        {tabValue === 1 && (
          <Paper sx={{ width: '100%' }}>
            <div className="header">
              <h4>Organisatie kaartlagen</h4>
              <p>
                U kunt per organisatie kaartlaag instellen welke u binnen uw organisatie zichtbaar wilt maken voor collega's.
              </p>

              <VisibilityLayers layerType={LayerType.ASSET} />
            </div>
          </Paper>
        )}

      </div>
      
      <Outlet /> 
    </>
  );
};

export default PageLayersDelen;